/**
 * Expiry date validator for card expiry fields.
 *
 * Validates MM/YY format: MM between 01–12, date is current month or future.
 *
 * Requirements: 10.4
 */
export const ExpiryValidator = {
  /**
   * Validate an expiry string in MM/YY format.
   * Returns true if MM is 01-12 and the expiry is the current month or in the future.
   */
  isValid(expiry: string, now?: Date): boolean {
    const match = expiry.match(/^(\d{2})\/(\d{2})$/);
    if (!match) return false;

    const month = parseInt(match[1], 10);
    const yearShort = parseInt(match[2], 10);

    if (month < 1 || month > 12) return false;

    const fullYear = 2000 + yearShort;
    const currentDate = now ?? new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // 1-indexed

    if (fullYear > currentYear) return true;
    if (fullYear === currentYear && month >= currentMonth) return true;

    return false;
  },
};
